import React from 'react'
import { Link } from 'react-router-dom';

const SidebarHome = (props) => {
    const { data } = props;
    
    return (
        <ul className="list-category-home">
            <Link className="btn btn-primary2 my-3 p-3 d-block w-75 m-auto fw-bold" to="/brands">Search By Brand</Link>
            {/* <hr /> */}

            {
                data.length > 0 && data.map((cat, i) => 
                    <li key={i}>
                        <Link className="fs-6" to={`/categories/${cat.slug}`}> {cat.name} </Link>
                    </li>
                )
            }
        </ul>
    )
}

export default SidebarHome
